import Vue from 'vue'
import VueRouter from 'vue-router'
import {  setToken,getToken,removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
import Layout from '@/layout'
// import Home from '../views/Home.vue'
// 缓存原型上的push函数
const originPush = VueRouter.prototype.push
const originReplace = VueRouter.prototype.replace
// 给原型对象上的push指定新函数函数
VueRouter.prototype.push = function (location, onComplete, onAbort) {
  // 判断如果没有指定回调函数, 通过call调用源函数并使用catch来处理错误
  if (onComplete===undefined && onAbort===undefined) {
    return originPush.call(this, location, onComplete, onAbort).catch(() => {})
  } else { // 如果有指定任意回调函数, 通过call调用源push函数处理
    originPush.call(this, location, onComplete, onAbort)
  }
}
VueRouter.prototype.replace = function (location, onComplete, onAbort) {
  if (onComplete===undefined && onAbort===undefined) {
    return originReplace.call(this, location, onComplete, onAbort).catch(() => {})
  } else {
    originReplace.call(this, location, onComplete, onAbort)
  }
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // name: 'home',
    // component: resolve => require(['@/views/home/index'], resolve),
    component:Layout,
    children:[
      {
        path:'',
        component: resolve => require(['@/views/home/index'], resolve),
        meta:{isToken:false},
      }
    ],
  },
  {
    path: '/order',
    // name: 'order',
    // component: resolve => require(['@/views/customerService/index'], resolve),
    component:Layout,
    children:[
      {
        path:'',
        component: resolve => require(['@/views/customerService/index'], resolve),
        meta:{isToken:true},
      }
    ],
  },
  {
    path: '/batchOrder',
    // name: 'order',
    // component: resolve => require(['@/views/customerService/index'], resolve),
    component:Layout,
    children:[
      {
        path:'',
        component: resolve => require(['@/views/batchOrder/index'], resolve),
        meta:{isToken:true},
      }
    ],
    
  },
  {
    path: '/product',
    // name: 'product',
    // component: resolve => require(['@/views/product/index'], resolve),
    component:Layout,
    children:[
      {
        path:'',
        component: resolve => require(['@/views/product/index'], resolve),
        meta:{isToken:false},
      }
    ],
  },
  {
    path: '/about',
    // name: 'about',
    // component: resolve => require(['@/views/about/index'], resolve),
    component:Layout,
    children:[
      {
        path:'',
        component: resolve => require(['@/views/about/index'], resolve),
        meta:{isToken:false},
      }
    ],
  },
  {
    path: '/login',
    component: resolve => require(['@/login/index.vue'], resolve),
    meta:{isToken:false},
  }
]

const router = new VueRouter({
  routes,
  mode:'history'
})
router.beforeEach((to,form,next) => {
  // console.log(to.meta.isToken)
  next();
  if(to.meta.isToken){
    if(getToken()){
      next();
    }else{
      Message('请登录后再进行下单操作');
      next({
        path:'/'

      })
    }
  }else{
    next();
  };
})
export default router
